const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogPraticasLinguagem(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPraticaDeLinguagem`, params);
    },
    $obterRelatorioLogCSVPraticasLinguagem(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPraticaDeLinguagemCsv`, params);
    },
    $obterRelatorioLogPDFPraticasLinguagem(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogPraticaDeLinguagemPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
